import {
  MplusPrepareOrderResponse,
  PrepareOrderApiArgs,
} from 'modules/Cart/model/types'

import { apiRoutes } from 'shared/config/apiPath/apiPath'
import { axiosInstance } from 'shared/config/axios/axiosInstance'

const baseMarketUrl = '/api'

export const commonApi = {
  async closeWebview(): Promise<void> {
    try {
      await axiosInstance.get(
        `${baseMarketUrl}${apiRoutes.mainPage.closeWebview}`,
      )
    } catch (error) {
      throw error
    }
  },
  async prepareOrderByMbank(body: PrepareOrderApiArgs): Promise<void> {
    try {
      await axiosInstance.post(
        `${baseMarketUrl}${apiRoutes.cart.prepareOrder}`,
        body,
      )
    } catch (error) {
      throw error
    }
  },
  async prepareOrderByMplus(
    body: PrepareOrderApiArgs,
  ): Promise<{ data: MplusPrepareOrderResponse }> {
    try {
      return await axiosInstance.post(
        `${baseMarketUrl}${apiRoutes.cart.mplusPrepareOrder}`,
        body,
      )
    } catch (error) {
      throw error
    }
  },
}
